// extracted by mini-css-extract-plugin
export default {"form":"AddQuote_form__CCjRy","input":"AddQuote_input__VMpaZ","button":"AddQuote_button__7BGoU"};